<form #form="ngForm" (ngSubmit)="saveTimesheet(form)">

  <!-- Row 1 -->
  <div class="p-fluid p-formgrid-del p-grid p-mt-2">
    <!--Timesheet Date-->
    <div class="p-field p-col-12 p-md-3">
      <span class="p-float-label">
        <p-calendar class="p-inputtext-sm" 
                    appendTo="body"
                    showIcon="true" 
                    dateFormat="dd/mm/yy"
                    inputId="timesheetDate"
                    name="timesheetDate"
                    required
                    #day="ngModel"
                    [maxDate]="maxDate"
                    [disabled]="!canModifyPastTimeSheet()"
                    [(ngModel)]="timesheet.day"
                    [class.field-error]="form.submitted && day.invalid"></p-calendar>
        <label for="timesheetDate" class="required-field">Date</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && day.invalid">Date is required</small>
    </div>

    <!--Job Codes -->
    <div class="p-field p-col-12 p-md-9">
      <span class="p-float-label">
        <p-dropdown [options]="jobCodes" 
                    inputid="jobCode"
                    name="jobCode"
                    class="p-inputtext-sm" 
                    appendTo="body"
                    showClear="true"
                    optionLabel="jobCodeNo"
                    required
                    #jobCode="ngModel"
                    [autoDisplayFirst]="false"
                    [filter]="true" filterBy="jobCodeNo" 
                    [(ngModel)]="timesheet.jobCode"
                    [class.field-error]="form.submitted && jobCode.invalid"></p-dropdown>
        <label for="jobCode" class="required-field">Job Code</label>
      </span>
      <small class="form-prompt" *ngIf="timesheet.jobCode">{{timesheet.jobCode?.description}}</small>
      <small class="p-error" *ngIf="form.submitted && jobCode.invalid">Job code is required!</small>
    </div>
  </div>

  <!-- Row 2 -->
  <div class="p-fluid p-grid">
    <!--Work Shits -->
    <div class="p-field p-col-12 p-md-3">
      <span class="p-float-label">
        <p-dropdown [options]="rosterCodes" 
                    inputid="shift"
                    name="shift"
                    class="p-inputtext-sm" 
                    appendTo="body"
                    showClear="true"
                    optionLabel="code"
                    required
                    #shift="ngModel"
                    [autoDisplayFirst]="false"
                    [(ngModel)]="timesheet.shift"
                    [class.field-error]="form.submitted && shift.invalid">
            <ng-template let-workshift pTemplate="item">
              <div>
                <span style="display:inline-block;width:40px;">{{workshift.code}}:</span> {{workshift.description}}
              </div>
            </ng-template>                    
          </p-dropdown>
        <label for="shift" class="required-field">Work Shift</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && shift.invalid">Work shift is required!</small>
    </div>

    <!--Man hour-->
    <div class="p-field p-col-12 p-md-2">
      <span class="p-float-label">
        <p-inputNumber  name="hours"
                        id="hours" 
                        class="p-inputtext-sm"
                        mode="decimal" 
                        [minFractionDigits]="2"
                        required
                        #hour="ngModel"
                        [class.field-error]="form.submitted && hour.invalid"
                        [(ngModel)]="timesheet.hours"></p-inputNumber>
        <label for="hours" class="required-field">Man Hour</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && hour.invalid">Man hour is required!</small>
    </div>

    <!--Note -->
    <div class="p-field p-col-12 p-md-7">
      <span class="p-float-label">
            <textarea pInputTextarea
                      id="note"
                      name="note"
                      class="p-inputtext-sm"
                      rows="1"
                      maxlength="500"
                      #note="ngModel"
                      [class.field-error]="form.submitted && note.invalid"
                      [(ngModel)]="timesheet.note"></textarea>
            <label for="hours">Note</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && note.invalid">Max length of note is 500 characters!</small>
    </div>
  </div>

  <!-- Row 3 -->
  <div class="p-fluid p-grid">
    <!--Work Shits -->
    <div class="p-field p-col-12 p-md-12">
      <span class="p-float-label">
        <p-dropdown [options]="groups" 
                    inputid="group"
                    name="group"
                    class="p-inputtext-sm" 
                    appendTo="body"
                    showClear="true"
                    optionLabel="name"
                    [autoDisplayFirst]="false"
                    (onChange)="loadEmployeesByGroup($event)"
                    [(ngModel)]="timesheet.workGroup"></p-dropdown>
        <label for="shift">Select Group</label>
      </span>
    </div>
  </div>
  <!-- Row 3 -->
  <div class="p-fluid p-grid" *ngIf="groupEmployees.length > 0">
    <div class="p-field p-col-12 p-md-12" style="height:200px;">
      <p-table [value]="groupEmployees" 
              [(selection)]="selectedEmployees" 
              [scrollable]="true" 
              styleClass="p-datatable-gridlines p-datatable-striped text-small"
              selectionMode="multiple"
              scrollHeight="160px"
              dataKey="id">
        <ng-template pTemplate="header">
          <tr class="table-header">
            <th style="width: 3rem;">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th>
              Employee Name <p-badge class="p-ml-3" [value]="selectedEmployees.length + ' / ' + groupEmployees.length"  severity="danger"></p-badge>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-emp let-rowIndex="rowIndex">
          <tr [pSelectableRow]="emp"  [pSelectableRowIndex]="rowIndex">
            <td style="width: 3rem">
                <p-tableCheckbox [value]="emp" (click)="$event.stopPropagation()"></p-tableCheckbox>
            </td>
            <td>{{util.getEmployeeName(emp)}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="modal-footer">
    <button pButton pRipple label="{{savingTimesheet ? 'Saving' : 'Save'}}" class="p-button p-button-raised" icon="pi pi-save" type="submit" 
            [disabled]="selectedEmployees?.length === 0 || savingTimesheet"></button>
    <button pButton pRipple label="Close" class="p-button p-button-raised p-button-outlined" icon="pi pi-times" type="button" (click)="close();"></button>
  </div>
</form>
